import { Route } from "@angular/router"
import { ClaimListComponent } from "./ui/claim-list/claim-list.component"
import { ClaimCreateComponent } from "./ui/claim-create/claim-create.component"

const claimRouters: Route[] = [
    {
      path: 'claims',
      children: [
        {
          path: '',
          component: ClaimListComponent
        },
        {
          path: 'create',
          component: ClaimCreateComponent
        }
      ]
    }
  ]
  
  export default claimRouters